import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../services/web/agent';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import oidcStore from './oidcStore';
import ToastrLevelsEnum from '../services/enums/toastrLevelsEnum';
import ToastrService from '../services/ui/toastrService';

class EditUserProfileStore {

    @observable updateProgileProgress;
    @observable firstNameValidationMessage;
    @observable lastNameValidationMessage;
    @observable emailValidationMessage;
    @observable passwordValidationMessage;
    @observable editUserProfileErrorMessage;

    @setter @observable authenticationProviderFormatted = '';

    @observable updateUserInProgress;
    @observable userLoaded = false;

    @observable profileValues = {
        firstName: '',
        lastName: '',
        userName: '',
        email: '',
        jobTitle: '',
        phoneNumber: '',
        cellPhoneNumber: '',
        country: '',
        other: '',
        localeId: '',
        teams: '',
        authenticationProviderId: -1,
        password: '',
        userProfileGoBackUrl: ''
    };

    formErrors = [];

    @action resetEditProfileValues() {
        for (let field in this.profileValues) {
            this.profileValues[field] = '';
        }
    }

    @action getUserProfile() {

        return agent.MyProfile.get()
            .then(action((userProfile) => {
                this.profileValues = userProfile;
                this.userLoaded = true;
                return userProfile;
            }
            ));
    }

    @action updateUserProfile() {

        this.updateUserInProgress = true;

        this.setEditUserProfileErrorMessage('');

        return agent.MyProfile.update(this.profileValues)
            .then(() => {

                oidcStore.startSilentRenew().catch((err) => {
                    console.log('startSilentRenew failed:' + err);
                });
            })
            .catch(action((err) => {
                this.editUserProfileErrorMessage = 'Failed to update profile';

                if (err && err.response && err.response.text) {
                    const errorMsg = JSON.parse(err.response.text).Message;
                    this.setEditUserProfileErrorMessage(errorMsg);

                    const level = ToastrLevelsEnum.ERROR;
                    const message = String(errorMsg);
                    ToastrService.triggerToastr({ level, message});
                }

                throw err;
            }))
            .finally(action(() => {
                this.updateUserInProgress = false;
            }));
    }

    validateFirstName() {

        const validation = userSharedFormsValidator.validateFirstName(this.profileValues.firstName);

        this.firstNameValidationMessage = validation.errors.first('firstName');

        this.formErrors.push(validation.errorCount);
    }


    validateLastName() {

        const validation = userSharedFormsValidator.validateLastName(this.profileValues.lastName);

        this.lastNameValidationMessage = validation.errors.first('lastName');

        this.formErrors.push(validation.errorCount);
    }

    validateEmail() {
        const validation = userSharedFormsValidator.validateEmail(this.profileValues.email);
        this.emailValidationMessage = validation.errors.first('email');

        this.formErrors.push(validation.errorCount);

    }

    validatePassword() {

        const validation = userSharedFormsValidator.validateRequiredPassword(this.profileValues.password);
        this.passwordValidationMessage = validation.errors.first('password');
        
        this.formErrors.push(validation.errorCount);
    }

    @action validateForm(isApplication) {

        this.formErrors = [];
        this.validateFirstName();
        this.validateLastName();
        this.validateEmail();

        if (isApplication) {
            this.validatePassword();
        }

        if (this.formErrors.filter(valid => valid > 0).length > 0) {

            return false;
        }

        return true;
    }

    @action setFirstName(firstName) {
        this.profileValues.firstName = firstName;
    }

    @action setLastName(lastName) {
        this.profileValues.lastName = lastName;
    }

    @action setJobTitle(jobTitle) {
        this.profileValues.jobTitle = jobTitle;
    }

    @action setEmail(email) {
        this.profileValues.email = email.trim();
    }

    @action setPhone(phoneNumber) {
        this.profileValues.phoneNumber = phoneNumber;
    }

    @action setCellPhoneNumber(cellPhoneNumber) {
        this.profileValues.cellPhoneNumber = cellPhoneNumber;
    }

    @action setCountry(country) {
        this.profileValues.country = country;
    }

    @action setOther(other) {
        this.profileValues.other = other;
    }

    @action setLocaleId(localeId) {
        this.profileValues.localeId = localeId;
    }

    @action setEditUserProfileErrorMessage(errorMsg) {
        this.editUserProfileErrorMessage = errorMsg;
    }

    @action setPassword(password) {
        this.profileValues.password = password;
    }

    @action resetForm = _ => {

        this.profileValues = {
            firstName: '',
            lastName: '',
            userName: '',
            email: '',
            jobTitle: '',
            phoneNumber: '',
            cellPhoneNumber: '',
            country: '',
            other: '',
            localeId: '',
            teams: '',
            authenticationProviderId: -1,
            password: '',
            userProfileGoBackUrl: ''
        };
    }

    @action resetValidations = _ => {

        this.formErrors = [];
        this.firstNameValidationMessage = '';
        this.firstNameValidationMessage = '';
        this.lastNameValidationMessage = '';
        this.emailValidationMessage = '';
        this.passwordValidationMessage = '';
    }
}

export default new EditUserProfileStore();